import { handleGetColecction, handleSelectedFirebase } from '@/constantes/helpers'
import firebase, { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()

/**
 * @param {Array} compras
 * @param {FILTROS_REPORTE} filtros
 */
const obtenerComprasFiltradas = (filtros, compras, getters) => {

  const sucursal = filtros.filtro2.sucursal
  let listaCompras = [...compras]

  if (sucursal.seleccionado) {
    if (sucursal.id) {

      compras.forEach(compra => {

        const almacen = getters.almacenes[compra.id_almacen]
        const idSucursal = almacen ? almacen.id_sucursal : null
        if (idSucursal !== sucursal.id) {
          listaCompras = listaCompras.filter(e => e.id !== compra.id)
        }

      })

    }
  }

  return listaCompras

}

/**
 * @param {firebase.firestore.Query<firebase.firestore.DocumentData>} docRef
 * @param {FILTROS_REPORTE} filtros
 */
const obtenerFiltrosAdicionalesCompras = (docRef, filtros) => {
  console.log("Filtros ", filtros)
  const { proveedor } = filtros.filtro1
  const { colaborador } = filtros.filtro2

  console.log(proveedor, colaborador)

  docRef = handleSelectedFirebase(docRef, proveedor, 'id_proveedor')
  docRef = handleSelectedFirebase(docRef, colaborador, 'id_responsable')

  return docRef

}

const store = {
  state: {
    compras: {},
  },
  getters: {
    compras: state => {
      return state.compras
    },
    indiceCompras: state => {

      const lista = []

      for (const i in state.compras) {

        const compra = state.compras[i]
        compra.id = i

        lista.push(compra)

      }
      console.log('indiceCompras', lista);
      
      return lista;

    }
  },
  mutations: {
    ASIGNA_COMPRAS(state, compras) {
      state.compras = compras
    },
  },
  actions: {

    async guardarCompra({ getters }, compra) {

      const data = { ...compra }
      const {franquicia} = getters

      data.fecha_alta = new Date()
      data.id_numerico = franquicia.id_ultima_compra ? franquicia.id_ultima_compra + 1 : 1

      const doc = await db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(franquicia.id)
        .collection(FS_COLLECTIONS.COMPRAS).add(data)

      await db
      .collection(FS_COLLECTIONS.FRANQUICIAS)
      .doc(franquicia.id)
      .update({
        id_ultima_compra:firebase.firestore.FieldValue.increment(1),
      })

      return doc

    },
    actualizarCompra({ getters }, props) {

      const { compra, id_compra } = props

      return new Promise((resolve, reject) => {

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.COMPRAS).doc(id_compra)
          .update(compra).then(() => {
            resolve()
          }).catch(e => {
            reject(e)
          })

      })

    },
    obtenerCompras({ getters, commit }) {

      return new Promise((resolve) => {

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.INDICES).doc(FS_COLLECTIONS.COMPRAS)
          .onSnapshot(doc => {

            commit('ASIGNA_COMPRAS', doc.data() || {})

            resolve()

          })

      })

    },
    async obtenerComprasFiltradas({ getters }, filtros) {

      const fechaDel = filtros.filtro1.fecha.del.fecha
      const fechaAl = filtros.filtro1.fecha.al.fecha
      const campo = 'fecha'

      let docRef = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.COMPRAS).where(campo, '>=', fechaDel).where(campo, '<=', fechaAl)
      docRef = obtenerFiltrosAdicionalesCompras(docRef, filtros)

      const compras = await handleGetColecction(docRef)

      return obtenerComprasFiltradas(filtros, compras, getters)

    },
    obtenerCompra({ getters }, id_compra) {

      return new Promise((resolve, reject) => {

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.COMPRAS).doc(id_compra).get().then(doc => {

            if (!doc.exists) reject("El documento no existe")
            resolve(doc.data())

          }).catch(e => {
            reject(e)
          })

      })

    },

    eliminarCompra({ getters }, id_compra) {

      return new Promise((resolve, reject) => {

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.COMPRAS).doc(id_compra).delete().then(() => {
            resolve()
          }).catch(e => {
            reject(e)
          })

      })

    },

  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/compras/index.js